import { Link } from 'react-router-dom';
import s from './TourCardList.module.scss';
import StarRating from '../../components/StarRating/StarRating';
import LazyLoad from 'react-lazyload';

const TourCardList = ({ items }) => {
  if(!items) return null;

  return (
    <div className={s.root}>
      <div className={s.container}>
        {items.map((item, index) => (
          <div key={index} className={s.card}>
            <div className={s.imageWrapper}>
              <Link to={`/tours/${item.tour_id}`}>
                <LazyLoad height={200} offset={100} once>
                  <img src={item.image1} alt={item.title} className={s.image} />
                </LazyLoad>
              </Link>
            </div>
            <div className={s.detailsContainer}>
              <Link to={`/tours/${item.tour_id}`}>
                <h3 className={s.title}>{item.title}</h3>
              </Link>
              <div className={s.rating}>
                <StarRating score={item.rating} />
                <p className={s.rate}>{item.rating}</p>
                <p className={s.count}>({item.review_count})</p>
              </div>
              <Link to={`/review/${item.rezdy_id}`} className={s.ratingLink} state={{
                breadcrumbItems: [
                  { name: 'ホーム', link: '/' },
                  { name: `${item.title}の口コミ`, link: '' }
                ]
              }}>
              </Link>
              <div className={s.tags}>
                {item.tags.map((tag, tagIndex) => (
                  <span key={tagIndex} className={s.tag}>{tag.name}</span>
                ))}
              </div>
              <p className={s.details}>{item.details}</p>
              <div className={s.spacer}></div>
              <div className={s.prices}>
                <p className={s.salePrice}>${Math.floor(item.sale_price)}</p>
                <p className={s.regularPrice}>${Math.floor(item.regular_price)}</p>
                <div className={s.label}>28%</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TourCardList;
